import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';
import 'tippy.js/dist/backdrop.css';
import 'tippy.js/animations/scale.css';
import './Header.css';

export default function NotificationsIcon({ svgClass, wrapperClass }) {
  return (
    <Tippy
      content={'Notifications'}
      className={'tippy-tooltip'}
      // delay={[1000, 0]}
      animation={'scale'}
      touch={false}>
      <div className={wrapperClass}>
        <svg className={svgClass} viewBox='0 0 87.05 90.12' fill='#fff'>
          <path d='M50.64,6.91c11.01,2.28,17.9,9.02,20.81,19.79,2.58,9.55-.59,19.95,2.56,28.99,2,5.73,5.8,6.73,9.77,10.28,4.18,3.74,4.9,8.75-1.15,10.7h-25.81c-.46,17.89-26.34,17.98-26.95,0H4.38c-2.73-.52-4.66-2.85-4.35-5.66.52-4.78,8.04-7.64,10.94-11.43,5.56-7.24,2.44-20.89,3.88-29.65,1.88-11.5,9.23-21.04,21.24-22.65.6-9.42,13.52-9.86,14.55-.37Z' />
        </svg>
      </div>
    </Tippy>
  );
}
